import { requestBuilder } from '../../http/RequestBuilder';
import type { GeneralResponse } from '../../http/types/Common';

interface InitiateMembershipCancellationBody {
    cancellationReason: string;
    cancellationNotes: string;
    cancellationDate: string;
    isImmediate: boolean;
    refundAmountCents?: number;
}

export const useInitiateMembershipCancellation = requestBuilder.mutation<
    GeneralResponse,
    InitiateMembershipCancellationBody,
    { id: string }
>({
    endpoint: ({ id }) => `/api/admin/memberships/${id}/initiate-cancellation`,
    method: 'POST',
});
